import { formatCurrency } from "@/common/utils/formatters";
import { AnpHistoricalPriceData } from "../types/anpHistoricalPrice.type";
import { typeStrategy } from "@/common/constants/typeStrategy.constant";
import { geosMap } from "@/common/constants/geosMap.constant";

export class AnpHistoricalPricesTransformer {
  static tableTransformer(geoType: keyof typeof typeStrategy) {
    return (anpPrices: AnpHistoricalPriceData[]) => {
      const geoKey = geosMap.find(({ type }) => type === geoType)?.parentKey;

      return anpPrices.map((anpPrice) => {
        return {
          product_display_name: anpPrice.product?.display_name || '',
          geo_display_name: anpPrice.geo?.display_name || '',
          geo_parent_display_name: geoKey && anpPrice.geo?.[geoKey as keyof typeof anpPrice.geo]?.display_name || '',
          min_resale_price: formatCurrency(Number(anpPrice.min_resale_price || 0)),
          average_resale_price: formatCurrency(Number(anpPrice.average_resale_price || 0)),
          max_resale_price: formatCurrency(Number(anpPrice.max_resale_price || 0)),
        };
      });
    };
  }
}
